const $window = $(window);
const $header = $('.header.has-animation');
const $tabs = $('.js-tabs');

const MD_MIN_WIDTH: number = 992;
const FPS_INTERVAL: number = 60;
const STICKY_OFFSET: number = 100;

const STICKY_CLASS: string = 'is-sticky';

let elapsed: number = 0;
let then: number = Date.now();
let lastTop: number = 0;

const header = {
  initialize() {
    if ($header.length) {
      this.checkStickyHeader();
      this.loop();
    }
  },

  loop(): void {
    const now = Date.now();
    elapsed = now - then;

    if (elapsed > FPS_INTERVAL) {
      this.checkStickyHeader();
      then = now;
    }

    requestAnimationFrame(this.loop.bind(this));
  },

  checkStickyHeader() {
    const top = $window.scrollTop();

    if (top === lastTop) {
      return;
    }

    lastTop = top;

    if (top > STICKY_OFFSET && !$header.hasClass(STICKY_CLASS)) {
      $header.addClass(STICKY_CLASS);

      if ($tabs.length) {
        $tabs.addClass(STICKY_CLASS);
      }
    } else if (top <= STICKY_OFFSET && $header.hasClass(STICKY_CLASS)) {
      $header.removeClass(STICKY_CLASS);

      if ($tabs.length) {
        $tabs.removeClass(STICKY_CLASS);
      }
    }
  },
};

export default header;
